import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  right_side: {
    position: 'relative',
    marginLeft: 'auto'
  }
}));
